export default "https://assets.egbcdn.net/assets/packs/_/images/app/ios/ios-en-1-33002dd39d6883c67a34f8588301929a.png";